import CurrencyValueUIModel from './currency-value';

class CurrencyPerLegUIModel {
  constructor({
    currency = {},
    farelogixDesignator = null,
    farelogixPrice = false,
    legCode = undefined,
  } = {}) {
    this.currency = new CurrencyValueUIModel(currency);
    this.farelogixDesignator = farelogixDesignator;
    this.farelogixPrice = farelogixPrice;
    this.legCode = legCode;
  }

  getLegCode() {
    return this.legCode;
  }

  toAPI() {
    return {
      'currency': this.currency ? this.currency.toAPI() : this.currency,
      'farelogixDesignator': this.farelogixDesignator,
      'farelogixPrice': this.farelogixPrice,
      'legCode': this.legCode,
    };
  }
}

export default CurrencyPerLegUIModel;
